// Costanti VAT condivise — DEVONO restare allineate a /app/backend/vat_modes.py
export const VAT_MODE_STANDARD = "standard";
export const VAT_MODE_REVERSE_SUBAPPALTO = "reverse_charge_subappalto";
export const VAT_MODE_REVERSE_EU = "reverse_charge_eu";
export const VAT_MODE_NON_IMPONIBILE_EXPORT = "non_imponibile_export";
export const VAT_MODE_ESENTE = "esente";
export const VAT_MODE_CUSTOM = "custom";

// Etichette UI (dropdown). Per la modalità "standard" non viene mostrata alcuna nota.
export const VAT_MODE_OPTIONS = [
  { value: VAT_MODE_STANDARD, label: "IVA standard (22%)" },
  { value: VAT_MODE_REVERSE_SUBAPPALTO, label: "Reverse charge — subappalto edile" },
  { value: VAT_MODE_REVERSE_EU, label: "Reverse charge — intra-UE / extra-UE" },
  { value: VAT_MODE_NON_IMPONIBILE_EXPORT, label: "Non imponibile (export / art. 8)" },
  { value: VAT_MODE_ESENTE, label: "Esente IVA (art. 10)" },
  { value: VAT_MODE_CUSTOM, label: "Operazione speciale (testo libero)" },
];

// Dicitura legale precompilata per ciascuna modalità (default editabile).
export const VAT_MODE_DEFAULT_LEGAL = {
  [VAT_MODE_STANDARD]: "",
  [VAT_MODE_REVERSE_SUBAPPALTO]: "Inversione contabile ex art. 17 c.6 lett. a) DPR 633/72",
  [VAT_MODE_REVERSE_EU]: "Operazione non soggetta ex art. 7-ter DPR 633/72",
  [VAT_MODE_NON_IMPONIBILE_EXPORT]: "Operazione non imponibile ex art. 8 DPR 633/72",
  [VAT_MODE_ESENTE]: "Operazione esente IVA ex art. 10 DPR 633/72",
  [VAT_MODE_CUSTOM]: "",
};

// Etichetta sintetica visibile nel riepilogo totali (UI + PDF).
export const VAT_MODE_SHORT = {
  [VAT_MODE_STANDARD]: "",
  [VAT_MODE_REVERSE_SUBAPPALTO]: "Reverse charge (subappalto)",
  [VAT_MODE_REVERSE_EU]: "Reverse charge (intra-UE)",
  [VAT_MODE_NON_IMPONIBILE_EXPORT]: "Operazione non imponibile",
  [VAT_MODE_ESENTE]: "Operazione esente",
  [VAT_MODE_CUSTOM]: "Operazione speciale",
};

export const isVatZero = (mode) => Boolean(mode) && mode !== VAT_MODE_STANDARD;
